(function () {
  'use strict';

  if (window._ddAuthStateInit) return;
  window._ddAuthStateInit = true;

  var cfg = window.__DD_AUTH || {};
  var root = document.documentElement;
  var serverIsCustomer = !!cfg.serverIsCustomer;
  var loginUrl = String(cfg.accountLoginUrl || '/account/login');
  var logoutUrl = String(cfg.accountLogoutUrl || '/account/logout');
  var TRANSITION_KEY = 'dd-auth-transition';

  function setAuthAttr(isCustomer) {
    root.setAttribute('data-glass-customer', isCustomer ? 'true' : 'false');
  }

  function currentAttrIsCustomer() {
    return root.getAttribute('data-glass-customer') === 'true';
  }

  function samePath(a, b) {
    try {
      var ua = new URL(a, window.location.origin);
      var ub = new URL(b, window.location.origin);
      return ua.pathname.replace(/\/+$/, '') === ub.pathname.replace(/\/+$/, '');
    } catch (e) {
      return String(a || '').replace(/\/+$/, '') === String(b || '').replace(/\/+$/, '');
    }
  }

  async function probeCustomer() {
    var res = await fetch('/account', {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow',
      cache: 'no-store'
    });
    return res.url.indexOf(loginUrl) === -1;
  }

  async function revalidateAuth(opts) {
    opts = opts || {};
    try {
      var isCustomer = await probeCustomer();
      var attrCustomer = currentAttrIsCustomer();

      if (isCustomer !== attrCustomer) {
        var current = window.location.pathname + window.location.search + window.location.hash;
        window.location.replace(current || '/');
        return;
      }

      setAuthAttr(isCustomer);
      if (opts.clearTransition) {
        try { sessionStorage.removeItem(TRANSITION_KEY); } catch (e) {}
      }
    } catch (e) {
      /* Keep server-rendered state when probe fails. */
    }
  }

  function markTransition(type) {
    try { sessionStorage.setItem(TRANSITION_KEY, String(type || 'unknown')); } catch (e) {}
  }

  setAuthAttr(serverIsCustomer);

  window.addEventListener('pageshow', function (event) {
    if (event && event.persisted) revalidateAuth({ clearTransition: true });
  });

  document.addEventListener(
    'click',
    function (e) {
      var link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (!href) return;
      if (samePath(href, logoutUrl) || samePath(href, '/account/logout')) {
        markTransition('logout');
      }
    },
    true
  );

  document.addEventListener('dd:auth:transition', function (e) {
    markTransition(e && e.detail && e.detail.type ? e.detail.type : 'custom');
  });

  try {
    var pending = sessionStorage.getItem(TRANSITION_KEY);
    if (pending) {
      revalidateAuth({ clearTransition: true });
    }
  } catch (e) {}

  window.ddAuthState = {
    markTransition: markTransition,
    revalidate: revalidateAuth
  };
})();
